import createLogger from '@salesforce/pwa-kit-runtime/utils/logger-factory'
import packageJson from '../../../package.json'
import {AdyenAlert} from './util/adyenHelper'

const loggerInstance = Object.freeze(createLogger({packageName: packageJson.name}))

class Logger {
    static info(step, message) {
        loggerInstance.info(composeLog(step, message))
    }

    static warn(step, message) {
        loggerInstance.warn(composeLog(step, message))
    }

    static error(step, message, multiSiteObj) {
        loggerInstance.error(composeLog(step, message))
        AdyenAlert(step, message, multiSiteObj)
    }

    static debug(step, message) {
        loggerInstance.debug(composeLog(step, message))
    }

    /**
     * Logs information to the log center by constructing a log object from the provided parameters.
     *
     * @param {Object} params - The parameters for logging.
     * @param {string} params.siteId - The site identifier for the log entry.
     * @param {string} params.loggerPrefix - The category or prefix for the logger.
     * @param {string} params.loggerType - The type of the logger.
     * @param {string} [params.url] - Optional URL associated with the log entry.
     * @param {string|Object} [params.request] - Optional request data, either as a JSON string or an object.
     * @param {string|Object} [params.response] - Optional response data, either as a JSON string or an object.
     * @param {string} [params.logMessage] - Optional log message to include in the log entry.
     *
     * @returns {void} This function does not return a value. It outputs the log object to the console.
     */
    static logToLogCenter(params) {
        let logObject = {
            siteID: params.siteId,
            category: params.loggerPrefix,
            type: params.loggerType
        }

        if (params.url) {
            logObject.url = params.url
        }

        if (params.request) {
            if (typeof params.request == 'string') {
                logObject.request = JSON.parse(params.request)
            } else {
                logObject.request = params.request
            }
        }

        if (params.response) {
            if (typeof params.response == 'string') {
                logObject.response = JSON.parse(params.response)
            } else {
                logObject.response = params.response
            }
        }

        if (params.logMessage) {
            logObject.logMessage = params.logMessage
        }

        console.info(JSON.stringify(logObject, null, 2))
    }
}

const composeLog = (step, message) => {
    const logMessage = message instanceof Object ? JSON.stringify(message) : message
    return `${packageJson.version} ${step ? step : ''} ${logMessage ? logMessage : ''}`
        .trim()
        .replace(/\s\s+/g, ' ')
}

export default Logger
